/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { type WebPage } from 'schema-dts'

import {
  extractArticleBody,
  getImageUrl,
  getModifiedDate,
  getPublishedDate,
  keywordsFromTags,
  publisherId
} from '@/utils/microdata'

type Meta = {
  firstPublishedAt?: string | null
  publishedAtTimestamp?: string | null
}

type Props = {
  data: Exclude<TemplateQueries, null>
  url: string
}
const MicrodataDefault: React.FC<Props> = ({ data, url }) => {
  const anyData = data as Record<string, unknown>
  const { meta, externalName, headline, excerpt, tags, seo, image } = anyData
  const datePublished = getPublishedDate(meta as Meta)
  const dateModified = getModifiedDate(
    meta as Meta & { publishedAtTimestamp?: string | null }
  )
  const keywords = keywordsFromTags(
    tags as readonly ({ externalName?: string | null } | null)[] | null
  )
  const img = getImageUrl(
    (seo as { image?: unknown })?.image ??
      (image as { url?: string | null; gatsbyImageData?: unknown } | null)
  )
  const name =
    (externalName as string) ??
    (headline as string) ??
    (seo as { title?: string })?.title
  const description =
    (excerpt as string) ?? (seo as { description?: string })?.description
  const articleBody = extractArticleBody(
    anyData,
    description as string | undefined
  )

  return (
    <JsonLd<WebPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name,
        description,
        image: img,
        keywords,
        text: articleBody,
        datePublished,
        dateModified,
        url,
        publisher: publisherId
      }}
    />
  )
}

export default MicrodataDefault
